/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * PolicyStatus
 */
export type GetInsurancePolicyItemResponsePolicyStatus = typeof GetInsurancePolicyItemResponsePolicyStatus[keyof typeof GetInsurancePolicyItemResponsePolicyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInsurancePolicyItemResponsePolicyStatus = {
  DEATH: 'DEATH',
  EXPIRED: 'EXPIRED',
  INFORCE: 'INFORCE',
  LAPSED: 'LAPSED',
  SURRENDERED: 'SURRENDERED',
  CHANGED_OWNER: 'CHANGED_OWNER',
} as const;
